import { getDateNoTime } from '@assets/js/dateUtils';
import VueCookies from 'vue-cookies';
import { keep2Decimal } from '@assets/js/regExUtil';

const userInfo = VueCookies.get('userInfo');
// 单据状态
const statusOptions1 = [
  { value: 0, label: '草拟' },
  { value: 1, label: '在批' },
  { value: 2, label: '生效' }
];
// 订单状态
const statusOptions2 = [
  { value: '已下发', label: '已下发' },
  { value: '未下发', label: '未下发' },
  { value: '失效', label: '失效' }
];
const statusOptions3 = [
  { value: '首次下发', label: '首次下发' },
  { value: '变更', label: '变更' }
];

export const tableProperties = [
  {
    label: '订单状态',
    prop: 'issued_status',
    itemType: 'select',
    options: statusOptions2,
    input: true,
    sortable: false,
    widthAuto: true,
    visible: userInfo.acct_id === 1
  },
  {
    label: '销售合同号',
    prop: 'rawmaterialscon_no',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '采购合同号',
    prop: 'rmatercontract_no',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '供应商简称',
    prop: 'chinese_supplier_name',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '合同金额',
    prop: 'contract_amount',
    itemType: 'input',
    input: false,
    sortable: true,
    widthAuto: true
  },
  {
    label: '合同日期',
    prop: 'contract_date',
    itemType: 'date',
    input: false,
    sortable: true,
    widthAuto: true,
    formatter: val => getDateNoTime(val, false)
  },
  {
    label: '要求交货日期',
    prop: 'estimated_delivery_date',
    itemType: 'date',
    input: false,
    sortable: true,
    widthAuto: true,
    formatter: val => getDateNoTime(val, false)
  },
  {
    label: '预计付款日期',
    prop: 'estimated_payment_date',
    itemType: 'date',
    input: false,
    sortable: true,
    widthAuto: true,
    formatter: val => getDateNoTime(val, false)
  },
  {
    label: '经办人',
    prop: 'procurement_operator_name',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '录入人',
    prop: 'stff_name',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '录入时间',
    prop: 'create_time',
    itemType: 'date',
    input: false,
    sortable: true,
    widthAuto: true,
    formatter: val => getDateNoTime(val, false)
  }
];

export const mainFormProperties = [
  {
    label: '销售合同号',
    prop: 'rawmaterialscon_no',
    model: null,
    itemType: 'input',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '采购合同号',
    prop: 'rmatercontract_no',
    model: null,
    itemType: 'input',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '合同金额',
    prop: 'contract_amount',
    model: null,
    itemType: 'input',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '供应商简称',
    prop: 'chinese_supplier_name',
    model: null,
    itemType: 'input',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '采购经办人',
    prop: 'procurement_operator_name',
    model: null,
    itemType: 'input',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '合同日期',
    prop: 'contract_date',
    model: null,
    itemType: 'dateNoTime',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '要求交货日期',
    prop: 'estimated_delivery_date',
    model: null,
    itemType: 'dateNoTime',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '预付款日期',
    prop: 'estimated_payment_date',
    model: null,
    itemType: 'dateNoTime',
    size: 'small',
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  // {
  //   label: '批次号',
  //   prop: 'batch_number',
  //   model: null,
  //   itemType: 'input',
  //   size: 'small',
  //   rules: { required: false, message: ' ' },
  //   maxlength: 50,
  //   disabled: true,
  //   show: true
  // },
  {
    label: '订单备注',
    prop: 'order_remarks',
    model: null,
    itemType: 'input',
    type: 'textarea',
    rows: 5,
    size: 'small',
    rules: { required: false, message: ' ' },
    split: 24,
    maxlength: 255,
    disabled: false,
    show: true
  }
];
export const subTableProperties = [
  { label: '状态', prop: 'status', itemType: 'input', input: false, sortable: false, widthAuto: false },
  { label: '物料编号', prop: 'rawmateria_no', itemType: 'input', input: true, sortable: false, widthAuto: false },
  { label: '中文品名', prop: 'chinese_name', itemType: 'input', input: true, sortable: false, widthAuto: false },
  { label: '英文品名', prop: 'english_name', itemType: 'input', input: true, sortable: false, widthAuto: false },
  { label: '采购类型', prop: 'purchase_type_deta', itemType: 'input', input: true, sortable: false, widthAuto: false },
  { label: '批次号', prop: 'batch_number', itemType: 'input', input: true, sortable: false, widthAuto: false },
  { label: '规格', prop: 'chinese_specification', itemType: 'input', input: false, sortable: false, widthAuto: false },
  { label: '单位', prop: 'prod_unit', itemType: 'input', input: false, sortable: false, widthAuto: false },
  { label: '采购单价￥', prop: 'purchase_unit_price', itemType: 'input', input: false, sortable: false, widthAuto: false },
  { label: '数量', prop: 'lossy_quantity', itemType: 'input', input: false, sortable: false, widthAuto: false },
  { label: '采购总价￥', prop: 'total_purchase_price', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '外包装数量', prop: 'outer_packaging_quantity', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '内包装数量', prop: 'inner_packaging_quantity', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '箱数', prop: 'carton_quantity', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '长cm', prop: 'outer_case_length_cm', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '宽cm', prop: 'outer_case_width_cm', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '高cm', prop: 'outer_case_height_cm', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '每箱体积m³', prop: 'outer_case_volume', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '总体积m³', prop: 'total_volume', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '每箱毛重kg', prop: 'gross_weight', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '总毛重kg', prop: 'total_gross_weight', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '每箱净重kg', prop: 'net_weight', itemType: 'input', input: false, sortable: false, widthAuto: false },
  // { label: '总净重kg', prop: 'total_net_weight', itemType: 'input', input: false, sortable: false, widthAuto: false },
  { label: 'HS CODE', prop: 'customs_code', itemType: 'input', input: false, sortable: false, widthAuto: false },
  {
    label: '工厂批次号',
    prop: 'mes_batch_number',
    itemType: 'input',
    input: false,
    sortable: false,
    widthAuto: false,
    subItem: { type: 'popoverInput', maxLength: 100 }
  },
  {
    label: 'CDC清关品名',
    prop: 'cdc_customs_name',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: false
  },
  {
    label: 'CDC编码',
    prop: 'cdc_number',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: false
  },
  { label: '操作', prop: 'operation', itemType: 'input', input: false, sortable: false, fixed: 'right', labelWidth: 220 }
];
export const dialogformProperties = [
  {
    label: '批次号',
    prop: 'batch_number',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '采购类型',
    prop: 'purchase_type_deta',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: false
  },
  {
    label: '物料编号',
    prop: 'rawmateria_no',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '采购类型',
    prop: 'purchase_type_deta',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '批次号',
    prop: 'batch_number',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '潘通色号',
    prop: 'pantone_color_code',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    maxlength: 30,
    disabled: false,
    show: true
  },
  {
    label: '中文品名',
    prop: 'chinese_name',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '英文品名',
    prop: 'english_name',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '柬文品名',
    prop: 'mtrl_namekh',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '缸号',
    prop: 'lot_number',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: false,
    maxlength: 20,
    show: true
  },
  {
    label: '数量',
    prop: 'quantity',
    model: null,
    itemType: 'input',
    size: 'small',
    max: 0,
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: false,
    show: true
  },
  {
    label: '总数量',
    prop: 'quantity_total',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '数量单位',
    prop: 'prod_unit',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: true
  },
  {
    label: '净重KG',
    prop: 'net_weight',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    input: (list, index, val) => (list[index].model = keep2Decimal(val)),
    maxLength: 13,
    disabled: false,
    show: true
  },
  {
    label: '海关编码',
    prop: 'customs_code',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: false
  },
  {
    label: '是否报关',
    prop: 'customs_declaration',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: false
  },
  {
    label: 'purmaterial_orders_item_id',
    prop: 'purmaterial_orders_item_id',
    model: null,
    itemType: 'input',
    size: 'small',
    split: 24,
    rules: { required: false, message: ' ' },
    disabled: true,
    show: false
  }
];
export const reminderTableProperties = [
  {
    label: '订单状态',
    prop: 'order_status',
    itemType: 'select',
    options: statusOptions3,
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '销售合同号',
    prop: 'rawmaterialscon_no',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '采购合同号',
    prop: 'rmatercontract_no',
    itemType: 'input',
    input: true,
    sortable: false,
    widthAuto: true
  },
  {
    label: '采购经办人',
    prop: 'stff_name',
    itemType: 'input',
    input: false,
    sortable: false,
    widthAuto: true
  },
  {
    label: '要求交货日期',
    prop: 'estimated_delivery_date',
    itemType: 'date',
    input: false,
    sortable: false,
    widthAuto: true,
    formatter: val => getDateNoTime(val, false)
  }
];
